/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import {
    rememberContributionForm,
    rememberContributionForms
} from '@/helpers/contributionForms'

export default {
    setForms(state, data) {
        state.forms = data;
        // L'onglet « Contributions » et les entrées de menu doivent savoir si
        // la commune exploite des propositions citoyennes avant d'avoir chargé
        // quoi que ce soit. `setForms` reçoit parfois un formulaire seul
        // (retour de création) : le helper l'ignore.
        rememberContributionForms(data);
    },
    setForm(state, data) {
        state.form = data;
        // Ouvrir la fiche d'un formulaire de contribution suffit à faire
        // apparaître l'onglet, sans attendre un passage par la liste complète.
        rememberContributionForm(data);
    },
    setFormsTypes(state, data) {
        state.types = data;
    },
    setNewForm(state, data) {
        state.newForm = data;
        // Idem après un enregistrement depuis l'éditeur : l'agent qui vient
        // d'activer le réglage voit l'onglet tout de suite.
        rememberContributionForm(data);
    },
    // Statuses loaded from /forms/{id}/statuses, keyed by form: they carry the
    // predefined reasons the status transition modal needs.
    setFormStatuses(state, { formId, statuses }) {
        state.formStatuses = { ...state.formStatuses, [formId]: statuses };
    },
};
